/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import CKEditorWrapperActionPlan from '@/components/Editor/CKEditorWrapperActionPlan';

interface DescriptionModalProps {
  visible: boolean;
  selectedRecord: any | null;
  descriptionValue: string;
  onCancel: () => void;
  onSave: (value: string) => void;
  /** Ẩn nút Áp dụng khi không có quyền sửa. */
  readOnly?: boolean;
}

export const DescriptionModal: React.FC<DescriptionModalProps> = ({
  visible,
  selectedRecord,
  descriptionValue,
  onCancel,
  onSave,
  readOnly = false,
}) => {
  // Sử dụng local state để tránh re-render parent component khi gõ
  const [localValue, setLocalValue] = useState(descriptionValue);

  // Sync localValue với descriptionValue khi modal mở hoặc descriptionValue thay đổi từ bên ngoài
  useEffect(() => {
    if (visible) {
      setLocalValue(descriptionValue);
    }
  }, [visible, descriptionValue]);

  const handleChange = (value: string) => {
    setLocalValue(value);
    // Không gọi onDescriptionChange mỗi lần gõ để tránh re-render parent
    // Chỉ update khi save
  };

  const handleSave = () => {
    onSave(localValue);
  };

  return (
    <Modal
      open={visible}
      title={`Mô tả công việc: ${selectedRecord?.tenCongViec || selectedRecord?.originalData?.congViec?.tenCongViec || ''}`}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Đóng
        </Button>,
        ...(readOnly ? [] : [
          <Button key="apply" type="primary" onClick={handleSave}>
            Áp dụng
          </Button>,
        ]),
      ]}
      width={800}
      centered
    >
      <CKEditorWrapperActionPlan
        type="inline"
        data={localValue}
        onChange={handleChange}
        disabled={readOnly}
        placeholder="Nhập nội dung mô tả công việc..."
        resizable
        minHeight={100}
        maxHeight={480}
        borderRadius={8}
        borderInput="1px solid #e5e7eb"
        className="cvda-detail-form-description-editor bg-white rounded-xl"
        config={{
          toolbar: [
            ['Bold', 'Italic', 'Underline', 'Strike', 'Blockquote', 'NumberedList', 'BulletList', 'Link', 'Image', 'CodeBlock', 'Table', 'HorizontalRule', 'Source'],
          ],
        }}
      />
    </Modal>
  );
};

